module.exports = __webpack_public_path__ + "static/media/attachments.cf240609.svg";